/**
 * URL-safe slug from a display string (used for formations, expert anchors, etc.)
 */
export function createSlug(title) {
  if (!title || typeof title !== 'string') return '';
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

/**
 * Anchor id for /experts#... — uses CMS slug/id when set, otherwise slugified name.
 */
export function getExpertAnchorId(trainer, index = 0) {
  if (!trainer || typeof trainer !== 'object') return `expert-${index}`;
  const raw = trainer.slug || trainer.id || createSlug(trainer.name || '');
  const cleaned = String(raw).replace(/^#/, '').trim();
  return cleaned || `expert-${index}`;
}
